import axios from "axios";
import { request } from "@/utils/request";
// 查询
export function selectBannerConfig(data) {
  return request({
    url: `/admin/bannerConfig/select`,
    method: "POST",
    data,
  });
}

// 新增
export function addBannerConfig(data) {
  return request({
    url: `/admin/bannerConfig/add`,
    method: "POST",
    data,
  });
}

/* 修改 */
export function updateBannerConfig(data) {
  return request({
    url: `/admin/bannerConfig/update`,
    method: "POST",
    data,
  });
}

// 删除
export function deleteBannerConfig(data) {
  return request({
    url: `/admin/bannerConfig/delete`,
    method: "POST",
    data,
  });
}
